import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { Badge } from "@/components/ui/badge";
import { Card, CardContent } from "@/components/ui/card";

function Mocked({ kind }) {
  return (
    <Card><CardContent className="p-8 text-center" data-testid={`payments-${kind.toLowerCase()}`}>
      <h3 className="font-display text-xl font-bold mb-2">{kind}</h3>
      <div className="text-muted-foreground text-sm">No payment gateway is wired yet — this view is <Badge className="mx-1">MOCKED</Badge>.
      Configure a provider under <span className="font-mono">Integrations → Payment gateways</span> (Stripe, Razorpay, PayPal) and live transactions will appear here.</div>
    </CardContent></Card>
  );
}

export default function Payments() {
  return (
    <div className="p-4 sm:p-6 lg:p-8 space-y-4 sm:space-y-6" data-testid="admin-payments">
      <div>
        <h1 className="font-display text-2xl sm:text-3xl font-black">Payments</h1>
        <p className="text-muted-foreground">Platform-wide payment, gateway and tax visibility.</p>
      </div>
      <Tabs defaultValue="transactions">
        <TabsList>
          <TabsTrigger value="transactions" data-testid="pay-tab-tx">Transactions</TabsTrigger>
          <TabsTrigger value="failed" data-testid="pay-tab-fail">Failed</TabsTrigger>
          <TabsTrigger value="refunds" data-testid="pay-tab-refunds">Refunds</TabsTrigger>
          <TabsTrigger value="gateways" data-testid="pay-tab-gw">Gateways</TabsTrigger>
          <TabsTrigger value="tax" data-testid="pay-tab-tax">Tax reports</TabsTrigger>
          <TabsTrigger value="revenue" data-testid="pay-tab-rev">Revenue reports</TabsTrigger>
        </TabsList>
        <TabsContent value="transactions"><Mocked kind="Transactions" /></TabsContent>
        <TabsContent value="failed"><Mocked kind="Failed payments" /></TabsContent>
        <TabsContent value="refunds"><Mocked kind="Refund requests" /></TabsContent>
        <TabsContent value="gateways"><Mocked kind="Gateway configuration" /></TabsContent>
        <TabsContent value="tax"><Mocked kind="Tax reports" /></TabsContent>
        <TabsContent value="revenue"><Mocked kind="Revenue reports" /></TabsContent>
      </Tabs>
    </div>
  );
}
